import { Link } from "react-router-dom"
import { config } from "../lib/config"

export const PrivacidadePage = () => {
  return (
    <main className="min-h-screen bg-white">
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <Link to="/" className="text-sm font-medium text-brand-600 hover:underline">
          ← Voltar
        </Link>
        <h1 className="mt-6 text-3xl font-bold text-slate-900">Política de privacidade</h1>
        <p className="mt-2 text-sm text-slate-500">Rascunho Fase 0 — ver também docs/governanca-lgpd.md</p>
        <div className="prose prose-slate mt-8 max-w-none text-sm leading-relaxed text-slate-700">
          <p>
            Tratamos dados de cadastro, operação fiscal e auditoria conforme bases legais de execução de contrato
            e obrigação legal. PII de destinatários é cifrada; certificados digitais são armazenados com envelope
            AES-256-GCM.
          </p>
          <p>
            Retemos documentos fiscais pelo prazo mínimo legal (5 anos). Você pode exercer direitos pelo e-mail{" "}
            <a href={`mailto:${config.supportEmail}`} className="text-brand-600 hover:underline">
              {config.supportEmail}
            </a>
            .
          </p>
        </div>
      </div>
    </main>
  )
}
